<template>
    <a-modal 
             :loading="isLoading"
             :visible="isVisible"
             :closable="false"
             width="300px"
    >
        <template slot="footer">
            <a-button type="primary" @click="handleOK">
                OK
            </a-button>
            <a-button type="primary" @click="handleCancel">
                Cancel
            </a-button>
        </template>
        <a-row type="flex" justify="start" class="icons-list">
             <a-col :flex="2">
                <a-icon :type="icon" />
            </a-col>
            <a-col :flex="2">
                <h5> {{ message }}</h5>
            </a-col>
        </a-row>

        <a-row type="flex" justify="start" class="icons-list">
            <a-col :flex="2">
                <a-statistic-countdown
                    title="Countdown"
                    :value="deadline"
                    style="margin-right: 50px"
                    @finish="onFinish"
                />
                <p> The App will be log out soon!!!</p>
            </a-col>
        </a-row>

    </a-modal>
</template>

<script>
export default {
    props : {
        isVisible : Boolean,
        message : String
    },
    data() {
        return {
            icon : 'loading',
            isLoading : false,
            deadline : 1000 * 60 * 2
        }
    },
    methods : {

        handleOK() {
            this.$emit('LOG_OUT_EVENT');
        },
        handleCancel() {
            this.isVisible = false;
        },
        onFinish() {
            this.$emit('LOG_OUT_EVENT');
        }
        
    },
    created() {
        this.isVisible = false;
    }
}
</script>

<style scoped>
</style>